import { h } from "preact";
import { useMemo } from "preact/hooks";

import PreviewBackgroundColor, { isDefaultPreviewBackgroundColor } from "../../../../foundation/api/model/colors/PreviewBackgroundColor";
import RawColor from "../../../../foundation/api/model/colors/RawColor";
import Color from "../../../../foundation/model/color";
import classname from "../../../../foundation/utils/classname";
import IconCheck from "../../Icons/IconCheck";
import ColorSelector from "../../ColorSelector";
import withMenuItem, { WithMenuItemProps } from "../withMenuItem";

import styles from "./MenuColorSelector.module.css";

interface Props extends WithMenuItemProps {
    colorValue: PreviewBackgroundColor;
    colors: RawColor[];
    onChange(itemValue: RawColor): void;
}

function MenuColorSelector({
    colorValue,
    colors,
    onChange
}: Props) {
    const colorModels = useMemo(() =>
        colors.map(color => new Color(color))
    , [colors]);

    const isCustomSelected = useMemo(() =>
        !isDefaultPreviewBackgroundColor(colorValue)
    , [colorValue]);

    function handleItemClick(newValue: RawColor) {
        onChange(newValue);
    }

    return (
        <div class={styles.colorSelector}>
            <h3 class={classname(styles.title, "body-1")}>
                Custom
                {isCustomSelected && <IconCheck class={styles.checkIcon}/>}
            </h3>
            <ColorSelector
                class={styles.selector}
                colors={colorModels}
                selectedColor={colorValue}
                withBorder
                onSelect={handleItemClick}/>
        </div>
    );
}

const MenuColorSelectorAsMenuItem = withMenuItem(MenuColorSelector);

export default MenuColorSelector;
export { MenuColorSelectorAsMenuItem };
